var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _rect7, _rect8, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBiosaludable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "biosaludable",
    xmlns: "http://www.w3.org/2000/svg",
    width: 232.985,
    height: 171.973,
    viewBox: "0 0 232.985 171.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #3b1716;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    className: "cls-1",
    width: 12.967,
    height: 164.628,
    rx: 6.483,
    transform: "translate(15.746)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    className: "cls-1",
    width: 12.967,
    height: 164.628,
    rx: 6.483,
    transform: "translate(111.023)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    className: "cls-1",
    width: 12.967,
    height: 122.714,
    rx: 6.483,
    transform: "translate(202.08 41.907)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    className: "cls-1",
    width: 12.967,
    height: 93.468,
    rx: 6.483,
    transform: "translate(117.507 14.619) rotate(90)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    className: "cls-1",
    width: 12.967,
    height: 93.468,
    rx: 6.483,
    transform: "translate(210.975 54.122) rotate(90)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    className: "cls-1",
    width: 12.967,
    height: 48.39,
    rx: 6.483,
    transform: "translate(0 171.965) rotate(-90)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    className: "cls-1",
    cx: 6.405,
    cy: 6.405,
    r: 6.405,
    transform: "translate(57.998 159.077)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    className: "cls-1",
    width: 12.967,
    height: 48.39,
    rx: 6.483,
    transform: "translate(93.445 171.973) rotate(-90)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    className: "cls-1",
    width: 12.967,
    height: 48.39,
    rx: 6.483,
    transform: "translate(184.595 171.965) rotate(-90)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    className: "cls-1",
    cx: 6.405,
    cy: 6.405,
    r: 6.405,
    transform: "translate(151.434 159.077)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiosaludable);
export default __webpack_public_path__ + "static/media/biosaludable.afda646876142a11e6155c88af8a05c9.svg";
export { ForwardRef as ReactComponent };